import {
  Button,
  TextField,
  Box,
  Typography,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material'
import PageAppBar from 'components/PageAppBar'
import { base_url } from 'env'
import { useState, useEffect } from 'react'
import { useLoaderData, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { BadgeModel } from 'types'

const unlockConditions = [
  { value: 'NB_POINTS', label: 'Nombre de points total' },
  { value: 'TOTAL_LENGHT', label: 'Temps total de lecture (en minutes)' },
  { value: 'NB_ACTIVITIES', label: "Nombre d'activités complétées" },
  {
    value: 'NB_TYPE_SPECIFIC_ACTIVITIES',
    label: "Nombre d'activités d'une catégorie spécifique",
  },
  {
    value: 'NB_DISCTINCT_ACTIVITIES',
    label: "Nombre d'activités distinctes complétées",
  },
]

const activityCategories = ['ludique', 'auto', 'renf', 'partag']

export default function BadgeEditPage() {
  const navigate = useNavigate()
  const initialData = useLoaderData() as BadgeModel
  const [badge, setBadge] = useState(initialData)
  const [isSaving, setIsSaving] = useState(false)

  useEffect(() => {
    setBadge(initialData)
  }, [initialData])

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | { name?: string; value: unknown }>
  ) => {
    const { name, value } = e.target
    setBadge((prev) => ({
      ...prev,
      [name as string]:
        name === 'unlockValue' ? Number(value) : (value as string),
    }))
  }

  const handleSelectChange = (e: any) => {
    const { name, value } = e.target
    setBadge((prev) => ({
      ...prev,
      [name]: value,
      unlockAuxilliaryValue:
        name === 'unlockCondition' && value !== 'NB_TYPE_SPECIFIC_ACTIVITIES'
          ? null
          : prev.unlockAuxilliaryValue,
    }))
  }

  const handleSubmit = () => {
    if (!badge.name || !badge.description || badge.unlockValue <= 0) {
      alert('Veuillez remplir tous les champs correctement.')
      return
    }

    setIsSaving(true)
    const token = localStorage.getItem('token')
    const { id, ...payload } = badge

    axios
      .put(`${base_url}/badge/${id}`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => {
        alert('Badge mis à jour avec succès !')
        navigate(`/badge/${id}`)
      })
      .catch((error) => {
        console.error('Failed to update badge:', error)
        alert('La mise à jour a échoué: ' + error.response?.data?.message)
      })
      .finally(() => {
        setIsSaving(false)
      })
  }

  return (
    <PageAppBar pageName={`Modifier: ${badge.name}`}>
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5rem',
          alignItems: 'center',
          padding: '2rem',
          maxWidth: '700px',
          margin: '0 auto',
        }}
      >
        <Typography variant="h5">Modifier le Badge</Typography>
        <TextField
          required
          fullWidth
          name="name"
          label="Nom du Badge"
          value={badge.name}
          onChange={handleChange}
        />
        <TextField
          required
          fullWidth
          multiline
          rows={3}
          name="description"
          label="Description"
          value={badge.description}
          onChange={handleChange}
        />
        <FormControl fullWidth>
          <InputLabel id="unlock-condition-label">
            Condition de Déblocage
          </InputLabel>
          <Select
            labelId="unlock-condition-label"
            name="unlockCondition"
            value={badge.unlockCondition}
            label="Condition de Déblocage"
            onChange={handleSelectChange}
          >
            {unlockConditions.map((condition) => (
              <MenuItem key={condition.value} value={condition.value}>
                {condition.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {badge.unlockCondition === 'NB_TYPE_SPECIFIC_ACTIVITIES' && (
          <FormControl fullWidth>
            <InputLabel id="aux-value-label">Catégorie d'Activité</InputLabel>
            <Select
              labelId="aux-value-label"
              name="unlockAuxilliaryValue"
              value={badge.unlockAuxilliaryValue || ''}
              label="Catégorie d'Activité"
              onChange={handleSelectChange}
            >
              {activityCategories.map((cat) => (
                <MenuItem key={cat} value={cat}>
                  {cat}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        <TextField
          required
          fullWidth
          name="unlockValue"
          label="Valeur Requise"
          type="number"
          value={badge.unlockValue}
          onChange={handleChange}
          inputProps={{
            min: 1,
          }}
        />

        <Button
          variant="contained"
          color="success"
          onClick={handleSubmit}
          disabled={isSaving}
          sx={{ mt: 2, minWidth: '150px' }}
        >
          {isSaving ? <CircularProgress size={24} /> : 'Sauvegarder'}
        </Button>
      </Box>
    </PageAppBar>
  )
}
